module.exports = __webpack_public_path__ + "static/media/t1.78fae496.png";